import ProTip from '../ProTip'

export default function PipedriveSection() {
  return (
    <>
      <p className="text-sm text-muted-foreground mb-2">
        If your team previously used Pipedrive, your historical data is available through a
        dedicated interface inside Grackle CRM. This gives you read-only access to your Pipedrive
        records while you transition to the new system.
      </p>
      <p className="text-sm text-muted-foreground mb-2">
        <span className="font-medium">How to access:</span> Click{' '}
        <span className="font-medium">Pipedrive</span> in the sidebar navigation to switch to the
        Pipedrive view. You will see a separate layout with its own dashboard and navigation.
      </p>
      <p className="text-sm text-muted-foreground mb-2">
        <span className="font-medium">Available data:</span>
      </p>
      <ul
        className="list-disc list-inside space-y-1 text-sm text-muted-foreground ml-2"
        role="list"
      >
        <li>
          <span className="font-medium">Organizations</span> — Company records (equivalent to
          Accounts)
        </li>
        <li>
          <span className="font-medium">People</span> — Contact records linked to organizations
        </li>
        <li>
          <span className="font-medium">Deals</span> — Sales opportunities with pipeline stages
        </li>
        <li>
          <span className="font-medium">Activities</span> — Tasks and scheduled events
        </li>
        <li>
          <span className="font-medium">Notes</span> — Communication and meeting notes
        </li>
        <li>
          <span className="font-medium">Leads</span> — Unqualified prospects
        </li>
        <li>
          <span className="font-medium">Products</span> — Product catalog for deals
        </li>
        <li>
          <span className="font-medium">Files</span> — Attached documents
        </li>
      </ul>
      <p className="text-sm text-muted-foreground mt-3 mb-3">
        This is a read-only mirror — you cannot edit Pipedrive data from within Grackle CRM. Use it
        as a reference while you build your records in the main CRM.
      </p>

      <ProTip>
        <span className="font-medium">Transitioning?</span> When working a deal that started in
        Pipedrive, open the Pipedrive view to check the history, then create the corresponding
        records in Grackle CRM. This way you carry forward the context while building your new
        pipeline.
      </ProTip>
    </>
  )
}
